// frontend/global/ads/ads.js

import './misc-ads.css';
